import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import {
  faCheck,
  faUsers,
  faUserFriends,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import './CurriculumPricing.css';

const CurriculumPricing = () => {
  const [isMonthly, setIsMonthly] = useState(true);
  const navigate = useNavigate();

  const handlePlanSelect = (plan) => {
    navigate('/make-payment', {
      state: {
        plan: plan.title,
        price: isMonthly ? (plan.discountedPrice) * 3 : (plan.discountedPrice * 10 + 9),
        duration: isMonthly ? ' 3 month' : ' year'

      }
    });
  };

  const plans = [
    {
      title: "Super Sixteen",
      description: "Perfect for collaborative learning",
      price: 2999,
      discountedPrice: 899,
      icon: faUserFriends,
      features: [
        "3 Classes per week",
        "16-20 students per class",
        "Engaging offline lectures",
        "Interactive group discussions",
        "Peer learning opportunities",
        "Regular assessments",
        "Study materials included",
        "Priority doubt clearing",
        "Free access to AI Tutor"
      ]
    },
    {
      title: "Milkyway Stars",
      description: "Our most popular plan",
      price: 1999,
      discountedPrice: 599,
      icon: faUsers,
      features: [
        "3 Classes per week",
        "Large open group of students",
        "Engaging live Online lectures",
        "Peer learning opportunities",
        "Interactive group discussions",
        "Regular assessments",
        "Study materials included",
        "Doubt clearing sessions",
        "Free access to AI Tutor"
      ]
    },
    {
      title: "Elite Eight",
      description: "Personalized learning experience",
      price: 5999,
      discountedPrice: 1799,
      icon: faUser,
      features: [
        "3 Classes per week",
        "8-10 students per class",
        "Engaging offline lectures",
        "More focused attention",
        "Enhanced interaction",
        "Regular assessments",
        "Study materials included",
        "Priority doubt clearing",
        "Free access to AI Tutor"
      ]
    }
  ];

  return (
    <div className="curriculum-pricing">
      <div className="pricing-header">
        <h1>Simple, transparent pricing</h1>
        <p>Choose the best plan for your learning journey</p>
        
        <div className="pricing-toggle">
          <span className={!isMonthly ? 'active' : ''}>Monthly plans</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={!isMonthly}
              onChange={() => setIsMonthly(!isMonthly)}
            />
            <span className="slider round"></span>
          </label>
          <span className={isMonthly ? 'active' : ''}>Annual plans</span>
        </div>

        <div className="discount-banner">
          <span className="discount-tag">70% OFF</span>
          <span className="discount-text">Limited Time Offer!</span>
        </div>
      </div>

      <div className="pricing-grid">
        {plans.map((plan, index) => (
          <div key={index} className={`pricing-card ${index === 1 ? 'popular' : ''}`}>
            {index === 1 && <div className="popular-tag">Most Popular</div>}
            <div className="plan-icon">
              <FontAwesomeIcon icon={plan.icon} />
            </div>
            <h2>{plan.title}</h2>
            <p className="plan-description">{plan.description}</p>
            
            <div className="price-section">
              <div className="original-price">₹{plan.price}/month</div>
              <div className="discounted-price">
                <span className="dollar">₹</span>
                <span className="amount">{isMonthly ? plan.discountedPrice : plan.discountedPrice * 10 + 9}</span>
                <span className="period">/{isMonthly ? 'month' : 'year'}</span>
              </div>
            </div>

            <button 
              className="choose-plan-btn"
              onClick={() => handlePlanSelect(plan)}
            >
              Choose this plan
            </button>

            <div className="features-list">
              {plan.features.map((feature, idx) => (
                <div key={idx} className="feature-item">
                  <FontAwesomeIcon icon={faCheck} className="check-icon" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="contact-sales">
        <p>Not sure which plan is right for you?</p>
        <a href="/demo-class" className="contact-link">Book a FREE Class</a>
      </div>
    </div>
  );
};

export default CurriculumPricing; 